import { query } from '@confluence/query-preloader-tools/entry-points/graphql';
import {
	type SpaceOverviewIdQueryType,
	type SpaceOverviewIdQueryVariables,
} from '@confluence/content-types-utils/entry-points/SpaceOverviewIdQuery';
import { SpaceOverviewIdQuery } from '@confluence/content-types-utils/entry-points/SpaceOverviewIdQuery.graphql';

export function preloadSpaceOverviewId(spaceKey: string): Promise<{
	result: { data: SpaceOverviewIdQueryType | null };
	hasErrors: boolean;
}> {
	return query<SpaceOverviewIdQueryType, SpaceOverviewIdQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: SpaceOverviewIdQuery,
		variables: {
			spaceKey,
		},
	}).then((result) => ({ result, hasErrors: result.hasErrors }));
}
